"use client";

import type { ReactNode } from "react";
import {
  ChatModelRunResult,
  type ChatModelAdapter,
} from "@assistant-ui/react";
import ApiService from "./api/api.service";
import { shortid } from "./id.service";

interface CustomModelAdapterConfig {
  provider?: string;
  model?: string;
  agent_type: 'build_chart' | 'onboarding' | 'analyst';
  thread_id: string;
}

export const defaultCustomModelAdapterConfig: CustomModelAdapterConfig = {
    provider: 'snowflake_cortex',
    model: 'gpt-4o',
    agent_type: 'build_chart',
    thread_id: shortid()
};

export const createCustomModelAdapter = (config: Partial<CustomModelAdapterConfig> = {}): ChatModelAdapter => ({

  async *run({ messages, abortSignal, context }) {
    const finalConfig = { ...defaultCustomModelAdapterConfig, ...config };
    const requestBody = {
      messages,
      stream: true,
      agent_type: finalConfig.agent_type,
      thread_id: finalConfig.thread_id,
      ...(finalConfig.provider && { provider: finalConfig.provider }),
      ...(finalConfig.model && { model: finalConfig.model }),
    };
    
    const stream = await ApiService.getInstance().requestStream('POST', '/chat/completions', requestBody);
    let text = "";
    let toolCalls = [];

    for await (const part of stream) {
      if (part.type === "error") {
        yield {
            content: [{ type: "text", text: "" }],
            status: {
              type: "incomplete",
              reason: "error",
              error: new Error(part.error)
            }
          } as ChatModelRunResult;
          return; // Exit the generator after error
      } else if (part.type === "tool-call") {
        if (part.status === 'in_progress') {
          toolCalls.push(part);
        } else if (part.status === 'complete') {
          toolCalls.push(part);

          yield {
            content: toolCalls,
          }

          // Reset the tool calls so we can send multiple tools in a row
          toolCalls = [];
        }
      } else if (part.type === "heartbeat") {
        // Handle heartbeat messages if needed
        continue;
      } else {
      
        //console.log('Part', part);
        text += part.text || "";
        part.text = text;
        yield {
          content: [part]
        } as ChatModelRunResult;
      }
    }

    console.log('We are done streaming');
  },
});


